// IEMAS frontend JS.
//
// Kept deliberately minimal — the brief calls for restrained, purposeful motion,
// not scripted animation. This file wires up the mobile nav toggle and a
// scrolled-state class on the sticky header so we can densify it after scroll.

(function () {
  'use strict';

  const ready = (fn) => {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  ready(() => {
    initStickyHeader();
    initMobileMenu();
    initBracketIntersection();
  });

  function initStickyHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;

    const update = () => {
      if (window.scrollY > 12) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function initMobileMenu() {
    const toggle = document.querySelector('[data-menu-toggle]');
    const panel = document.querySelector('[data-menu-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      panel.classList.toggle('is-open', !expanded);
      document.body.style.overflow = !expanded ? 'hidden' : '';
    });

    // Close menu when navigating.
    panel.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        toggle.setAttribute('aria-expanded', 'false');
        panel.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  // Subtle reveal animation for bracket frames as they scroll into view.
  function initBracketIntersection() {
    const frames = document.querySelectorAll('.bracket-frame, [data-reveal]');
    if (!frames.length || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );

    frames.forEach((el) => observer.observe(el));
  }
})();
